import { useEffect, useContext } from 'react'
import * as rtc from './WebRTC/Rtc'
import Rtc from './WebRTC/Rtc'

import {useLocation, Link} from 'react-router-dom'

import { FaArrowLeft} from 'react-icons/fa';
import Chat from './Chat';
import RunCard from './RunCard';
import { UserContext } from '../Context/Context'
import { globalIsGuest as isGuest }  from "./WebRTC/Rtc";




const Lobby = () => {

    
    const {user, setUser} = useContext(UserContext)
    const location = useLocation();
    useEffect(() => {
        rtc.StartPeerConnection()

    }, []);


    function ClickHandler(e){
        if (localStorage.getItem('IsGuest') === 'false'){
            setGameMode(e.target.checked)
        }else {
            e.preventDefault()
        }
        //localstorage set gameMode
        //send to peer to check checkbox and set gameMode
    }

    function setGameMode(bool){
        localStorage.setItem('VersusGameMode', bool)
        rtc.sendDataChannel({type: 'setGameMode', isChecked: bool})
    }

    return (
        <div className="wrapper">
            <div style={{display:'flex'}}>
                <Link to="/multiplayer"><FaArrowLeft className='arrow' /*onClick = {() => {rtc.CloseConnection(location.state.Run.id)}}*/ ></FaArrowLeft></Link>
                <h2 className="header">Lobby</h2>
                <input onClick={(e) => {ClickHandler(e)}} class="toggle" type="checkbox" />
            </div>
            <div style={{marginTop:'3rem'}} className='flex-container'>
                <div className='runner-container'>
                    <Chat></Chat>
                </div>
                <div className='runs-container lobby_runners'>
                    <RunCard name={user.displayName} isLobby={true} isMine={true} ></RunCard>
                    {isGuest === null ? <RunCard name='Waiting for the boys...' isLobby={true} isMine={false} ></RunCard> : <RunCard name='Waiting for the boys...' isLobby={true} isMine={false} ></RunCard>}
                </div>
            </div>
            <Rtc></Rtc>
        </div>
    )
}

export default Lobby
